import { JarvisProduct } from '@vfde-sails/avc-core';
import { MetacodePrefix } from '../../../enums/product';

// TODO: Rework based on PR 66 (and debug this)
export const updateRegioChargeLinks = (
    currentProducts: JarvisProduct[],
    afterVpProducts?: JarvisProduct[]
) => {
    let updatedTariffs: JarvisProduct[] = [];

    currentProducts.forEach(product => {
        const afterVpProduct = afterVpProducts?.find(p => product.id === p.id);

        updatedTariffs.push({
            ...product,
            afterVpProductInfo: afterVpProduct?.productInfo,
            upload: afterVpProduct?.upload || product.upload,
        });
    });

    return updatedTariffs;
};

export const filterOnlyCableMetacodes = (metacodes: string[]) =>
    metacodes.filter(id => id.toLowerCase().includes(MetacodePrefix.CABLE));
